export const getCompleteMessage = (type: string | undefined) => {
  switch (type) {
    case '0':
      return '서비스 가입이 완료되었습니다.';
    case '2':
      return '서비스 가입이 완료되었습니다.<br/><br/>앱 다운로드 후 실행 시,<br/>카카오 이모티콘 쿠폰이 1시간 내에 발송될 예정입니다. 쿠폰 발송전, 서비스해지 시 쿠폰이 발송되지 않습니다.';
    case '3':
      return '만65세 이상 무료 가입이 완료되었습니다.';
    case '4':
      return '서비스 가입이 완료되었습니다.<br/><br/>이벤트 쿠폰은 SMS로 전송해 드리며,<br/>내일 오후 일괄적으로 발송됩니다.';
    default:
      return '이미 서비스에 가입된 고객입니다.';
  }
};
